import React, { useEffect, useState, memo } from "react";
import "../Css/Aside.css";
import { Link, useLocation } from "react-router-dom";
import $ from "jquery";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaCopy, FaCheck } from 'react-icons/fa'; // Import the copy and check icons from react-icons
import adminStorage from "../../utils/adminStorage";

const Aside = memo(() => {
  const [copied, setCopied] = useState(false);
  const [allowed, setAllowed] = useState(false);
  const [userDetails, setUserDetails] = useState({
    details: null,
    AgencyDetails: null,
    AgencyADetails: null,
    bD: null,
    coinDetails: null
  });
  const location = useLocation();

  // Initialize user details from sessionStorage once
  useEffect(() => {
    try {
      const data = adminStorage.getItem('data');
      const agencyDetail = sessionStorage.getItem("agency");
      const agencyADetail = sessionStorage.getItem("agencyadmin");
      const bdd = sessionStorage.getItem("bd");
      const coinDetail = sessionStorage.getItem("coin");

      setUserDetails({
        details: data ? JSON.parse(data) : null,
        AgencyDetails: agencyDetail ? JSON.parse(agencyDetail) : null,
        AgencyADetails: agencyADetail ? JSON.parse(agencyADetail) : null,
        bD: bdd ? JSON.parse(bdd) : null,
        coinDetails: coinDetail ? JSON.parse(coinDetail) : null
      });

      if (data) {
        const adminAccess = JSON.parse(data);
        setAllowed(adminAccess.access === '1');
      }
    } catch (error) {
      console.error('Error parsing session storage data:', error);
    }
  }, []);

  // Fix dropdown behavior - ensure only one dropdown is open at a time
  useEffect(() => {
    const handleDropdownClick = function(e) {
      e.preventDefault();
      
      // Get the target collapse element
      const target = $(this).attr("href");
      const isCurrentlyOpen = $(target).hasClass("show");
      
      // Close all open dropdowns first
      $(".collapse.show").removeClass("show");
      $(".sidebar-menu a[data-toggle='collapse']").attr("aria-expanded", "false");
      
      // If the clicked dropdown wasn't open, open it
      if (!isCurrentlyOpen) {
        $(target).addClass("show");
        $(this).attr("aria-expanded", "true");
      }
    };

    // Add a small delay to ensure DOM is fully rendered
    const timer = setTimeout(() => {
      // Remove any existing event handlers and add new ones
      $('.sidebar-menu a[data-toggle="collapse"]').off('click.dropdown');
      $('.sidebar-menu a[data-toggle="collapse"]').on('click.dropdown', handleDropdownClick);
    }, 100);

    // Cleanup function
    return () => {
      clearTimeout(timer);
      $('.sidebar-menu a[data-toggle="collapse"]').off('click.dropdown');
    };
  }, []);

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // Determine current panel based on location
  const pathname = location.pathname;
  const isAdminPanel = pathname.startsWith('/admin');
  const isAgencyAdminPanel = pathname.startsWith('/agencyadmin');
  const isAgencyPanel = pathname.startsWith('/agency') && !pathname.startsWith('/agencyadmin');
  const isBdPanel = pathname.startsWith('/bd');
  const isCoinPanel = pathname.startsWith('/coin');

  const { details, AgencyDetails, AgencyADetails, bD, coinDetails } = userDetails;

  // Don't render until we have the necessary data
  if (isAdminPanel && !details) return <div>Loading...</div>;
  if (isAgencyAdminPanel && !AgencyADetails) return <div>Loading...</div>;
  if (isAgencyPanel && !AgencyDetails) return <div>Loading...</div>;
  if (isBdPanel && !bD) return <div>Loading...</div>;
  if (isCoinPanel && !coinDetails) return <div>Loading...</div>;

  return (
    <>
      {isAdminPanel ? (
        <aside
          className="main-sidebar"
          style={{ maxHeight: "95vh", overflow: "auto" }}
        >
          <section className="sidebar">
            <div className="user-panel">
              <div className="pull-left image">
                <img
                  src={`${process.env.REACT_APP_BASEURL}${details.image}`}
                  className="img-circle"
                  alt="User Image"
                  style={{ height: "50px", width: "50px" }}
                />
              </div>
              <div className="pull-left info">
                <p>{details.name}</p>
                <a href="#">
                  <i className="fa fa-circle text-success" /> Online
                </a>
              </div>
            </div>
            <ul
              className="sidebar-menu"
              dataWidget="tree"
              id="iq-sidebar-toggle"
            >
              {/* ============================================================================== */}
              {/* MASTER */}
              {/* ============================================================================== */}
              <li className="active">
                <a href="/admin">
                  <i className="fa fa-dashboard" />
                  Dashboard
                </a>
              </li>
              <li className="">
                <Link to="/admin/map">
                  <i className="fa fa-map-marker" />
                  Live Map
                </Link>
              </li>
              <li className="">
                <Link to="/admin/balance">
                  <i class="fa-solid fa-coins"></i>
                  Balance
                </Link>
              </li>
              <li className="header">Splash Image</li>
              <li className="LINK_CLASS">
                <Link to="/admin/splashimage">
                  <i className="fa fa-diamond" />
                  Add splash Image
                </Link>
              </li>
              <li className="header">ACCOUNTS MANAGEMENT MASTER</li>
              {/* Master : Users e */}
              {/* ritul */}
              <li>
                <a
                  href="#user-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-users" /> <span>Users</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="user-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="admin/manageUser">
                      <i className="fa fa-circle-o" />
                      View Users
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/admin/liveUser">
                      <i className="fa fa-circle-o" />
                      Live User
                    </Link>
                  </li> */}
                  <li>
                    <Link to="/admin/pushMessage">
                      <i className="fa fa-circle-o" />
                      Push Messages
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/bannedUsers">
                      <i className="fa fa-circle-o" />
                      Banned Users
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/videoBannedUsers">
                      <i className="fa fa-circle-o" />
                      Video Banned Users
                    </Link>
                  </li>
                  <li>
                    <Link to="admin/removedranking">
                      <i className="fa fa-circle-o" />
                      Test Users
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/usernameHistory">
                      <i className="fa fa-circle-o" />
                      Username History
                    </Link>
                  </li>
                </ul>
              </li>
              {/* divansh */}
              {/* Master : Host s */}
              <li>
                <a
                  href="#Host-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-user" /> <span>Host</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Host-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/applyHost">
                      <i className="fa fa-circle-o" />
                      Apply Host
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/pendingHost">
                      <i className="fa fa-circle-o" />
                      Pending Host Request
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/approvedHost">
                      <i className="fa fa-circle-o" />
                      Approved Host Request
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/rejectedHost">
                      <i className="fa fa-circle-o" />
                      Rejected Host Request
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/hostrecord">
                      <i className="fa fa-circle-o" />
                      Host Record
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/PkBattleList">
                      <i className="fa fa-circle-o" />
                      Pk Record
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href="#Host-widthdrawal"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-user" /> <span>WithDrawal</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Host-widthdrawal"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  {/* <li>
                    <Link to="/admin/applyHost">
                      <i className="fa fa-circle-o" />
                      Apply Host
                    </Link>
                  </li> */}
                  <li>
                    <Link to="/admin/widthdrawal/pending">
                      <i className="fa fa-circle-o" />
                      Pending WithDrawal
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/widthdrawal/approved">
                      <i className="fa fa-circle-o" />
                      Approved WithDrawal
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/widthdrawal/rejected">
                      <i className="fa fa-circle-o" />
                      Rejected WithDrawal
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/withdrawalbdlists">
                      <i className="fa fa-circle-o" />
                      Total WithDrawal
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/withdrawalfamilylists">
                      <i className="fa fa-circle-o" />
                      Family WithDrawal
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/storedwithdrawalbdlists">
                      <i className="fa fa-circle-o" />
                      Total With. Stored Bd
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/TotalWithStoredAgency">
                      <i className="fa fa-circle-o" />
                      Total With. Stored Agency
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/storedwithdrawalfamilylists">
                      <i className="fa fa-circle-o" />
                      Family With. Stored
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href="#F-widthdrawal"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-user" /> <span>F. WithDrawal</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="F-widthdrawal"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  {/* <li>
                    <Link to="/admin/applyHost">
                      <i className="fa fa-circle-o" />
                      Apply Host
                    </Link>
                  </li> */}
                  <li>
                    <Link to="/admin/pendingfamilywalletwith">
                      <i className="fa fa-circle-o" />
                      Pending WithDrawal
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/approvedfamilywalletwith">
                      <i className="fa fa-circle-o" />
                      Approved WithDrawal
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/rejectedfamilywalletwith">
                      <i className="fa fa-circle-o" />
                      Rejected WithDrawal
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/FamilyWalletWithdrawalAdmin">
                      <i className="fa fa-circle-o" />
                      Family Wallet With.
                    </Link>
                  </li>

                </ul>
              </li>
              {/* Master : premium s */}
              <li>
                <a
                  href="#Family-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i
                    class="fa-regular fa-star"
                    style={{ marginRight: "4px" }}
                  ></i>
                  <span>Family</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Family-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/familycount">
                      <i className="fa fa-circle-o" />
                      Manage Family
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/familyrankrewards">
                      <i className="fa fa-circle-o" />
                      Family Rank Rewards
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/familyleave">
                      <i className="fa fa-circle-o" />
                      Leave Family
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/FamilyHistory">
                      <i className="fa fa-circle-o" />
                      Family History
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Vulgar : premium s */}
              <li className="LINK_CLASS">
                <Link to="admin/sendingRecievingRanking">
                  <i className="fa fa-diamond" />
                  SendingRecieving Rank
                </Link>
              </li>

              <li className="LINK_CLASS">
                <Link to="admin/GetTargetWithdrawl">
                  <i className="fa fa-diamond" />
                  Target Withdrawl
                </Link>
              </li>
              <li className="LINK_CLASS">
              <a
                  href="#user-live-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i
                    class="fa-regular fa-star"
                    style={{ marginRight: "4px" }}
                  ></i>
                  <span>User Live </span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="user-live-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                  <Link to="admin/livetime">
                  <i className="fa fa-diamond" />
                  Live Time
                  </Link>
                  </li>
                  <li>
                    <Link to="/admin/livetimeUser">
                      <i className="fa fa-circle-o" />
                      Special User 
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/GetLiveAmountInRange">
                      <i className="fa fa-circle-o" />
                      LiveAmount InRange 
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="LINK_CLASS">
                <Link to="admin/videos">
                  <i className="fa fa-diamond" />
                  Videos
                </Link>
              </li>
              
              <li>
                <a
                  href="#Vulgar-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i
                    class="fa-regular fa-star"
                    style={{ marginRight: "4px" }}
                  ></i>
                  <span>Vulgar</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Vulgar-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/vulgar">
                      <i className="fa fa-circle-o" />
                      View Vulgar Lists
                    </Link>
                  </li>
                </ul>
              </li>
              {/* secretkey : premium s */}
              <li>
                <a
                  href="#secretkey-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i
                    class="fa-regular fa-star"
                    style={{ marginRight: "4px" }}
                  ></i>
                  <span>Secretkey</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="secretkey-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/secretkey">
                      <i className="fa fa-circle-o" />
                      View Secretkeys
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="header">Other Pannel</li>
              {/* Master : premium s */}
              <li>
                <a
                  href="#bd-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-coins"></i>
                  <span>BD Panel</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="bd-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addBd">
                      <i className="fa fa-circle-o" />
                      Add BD Panel
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageBd">
                      <i className="fa fa-circle-o" />
                      Manage BD Panel
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/BillList">
                      <i className="fa fa-circle-o" />
                      BD Bills
                    </Link>
                  </li>
                   <li>
                    <Link to="/admin/BdKycList">
                      <i className="fa fa-circle-o" />
                      Bd KycList
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href="#coin-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-coins"></i>
                  <span>Coin Panel</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="coin-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addCoin">
                      <i className="fa fa-circle-o" />
                      Add Coin Agency
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageCoin">
                      <i className="fa fa-circle-o" />
                      Manage Coin Agency
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/CoinPanelRanking">
                      <i className="fa fa-circle-o" />
                      CoinsSend Ranking
                    </Link>
                  </li>
                   <li>
                    <Link to="/admin/CoinKycList">
                      <i className="fa fa-circle-o" />
                      Coin KycList
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Agency Adminpanel */}
              <li>
                <a
                  href="#AgencyAdminManage-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-user-secret"></i>{" "}
                  <span>Agency Admin Panel </span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="AgencyAdminManage-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addagencyadmin">
                      <i className="fa fa-circle-o" />
                      Add Agency Admin
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageagencyadmin">
                      <i className="fa fa-circle-o" />
                      Manage Agency Admin
                    </Link>
                  </li>
                   <li>
                    <Link to="/admin/AgencyAdminKycList">
                      <i className="fa fa-circle-o" />
                      Agency Admin KycList
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Master : Agency s */}
              <li>
                <a
                  href="#AgencyManage-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-user-secret"></i> <span>Agency Panel</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="AgencyManage-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addAgency">
                      <i className="fa fa-circle-o" />
                      Add Agency
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageAgency">
                      <i className="fa fa-circle-o" />
                      Manage Agency
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/agencyRanking">
                      <i className="fa fa-circle-o" />
                      Agency Ranking
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/BillListAgency">
                      <i className="fa fa-circle-o" />
                      Agency Bills
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/AgencyKycList">
                      <i className="fa fa-circle-o" />
                      Agency KycList
                    </Link>
                  </li>
                </ul>
              </li>
              {/*WorkFlow User */}
              {allowed?(
                <li>
                <a
                  href="#WorkflowUser-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-user-secret"></i> <span>Workflow User</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="WorkflowUser-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addWorkFlowUser">
                      <i className="fa fa-circle-o" />
                      Add WorkflowUser
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageWorkflowUser">
                      <i className="fa fa-circle-o" />
                      Manage WorkFLow User
                    </Link>
                  </li>
                </ul>
              </li>
              ):null}
              {/* ================================= */}
              {/* Badge & Gifts */}
              {/* ================================= */}
              <li className="header">BADGES &amp; GIFT</li>
              {/* Master : premium s */}
              <li>
                <a
                  href="#Vip-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i
                    class="fa-regular fa-star"
                    style={{ marginRight: "4px" }}
                  ></i>{" "}
                  <span>Vip Badges</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Vip-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addVip">
                      <i className="fa fa-circle-o" />
                      Add VIP Badges
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageVip">
                      <i className="fa fa-circle-o" />
                      Manage VIP Badges
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Master : Banners s */}
              <li>
                <a
                  href="#Banners-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i
                    class="fa-regular fa-clone"
                    style={{ marginRight: "5px" }}
                  ></i>{" "}
                  <span>Banners</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Banners-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addBanner">
                      <i className="fa fa-circle-o" />
                      Add Banners
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageBanner">
                      <i className="fa fa-circle-o" />
                      Manage Banners
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link
                  to="/admin/addd"

                >
                  <i
                    class="fa-regular fa-clone"
                    style={{ marginRight: "5px" }}
                  ></i>{" "}
                  <span>Ads</span>

                </Link>
              </li>

              {/* Master : Official tag s */}
              <li>
                <a
                  href="#ev-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-tag"></i> <span>Events</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="ev-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addEvent">
                      <i className="fa fa-circle-o" />
                      Add Event
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/GetEvents">
                      <i className="fa fa-circle-o" />
                      View Events
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href="#pk-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-tag"></i> <span>FamilyPk</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="pk-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addslap">
                      <i className="fa fa-circle-o" />
                      Add Slap
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/viewslap">
                      <i className="fa fa-circle-o" />
                      View Slap
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/addwinningslap">
                      <i className="fa fa-circle-o" />
                      Add WinningSlap
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/viewwinningslap">
                      <i className="fa fa-circle-o" />
                      View WinningSlap
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/FamilyPkRuleForm">
                      <i className="fa fa-circle-o" />
                      Add FamilyPkRules
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/ViewFamilyPkRuleForm">
                      <i className="fa fa-circle-o" />
                      View FamilyPkRules
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/PKBattleComponent">
                      <i className="fa fa-circle-o" />
                      FamilyPk
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/FamilyPKBattle">
                      <i className="fa fa-circle-o" />
                      CreatePkBanner-Final
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/PKBattleRoundFirst">
                      <i className="fa fa-circle-o" />
                      PKBattle Round1
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/PKBattleRoundSecond">
                      <i className="fa fa-circle-o" />
                      PKBattle Round2
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/PKBattleRoundThird">
                      <i className="fa fa-circle-o" />
                      PKBattle Round3
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/PKBattleRoundFinal">
                      <i className="fa fa-circle-o" />
                      PKBattle RoundFinal
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/categoryBanner">
                      <i className="fa fa-circle-o" />
                      Category Banner
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/admin/hipe/hipebanner">
                      <i className="fa fa-circle-o" />
                      Hipe Banner1
                    </Link>
                  </li> */}
                </ul>
              </li>
              <li>
                <a
                  href="#Officialtags-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-tag"></i> <span>Official Tags</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Officialtags-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addTag">
                      <i className="fa fa-circle-o" />
                      Add Official Tag
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageTag">
                      <i className="fa fa-circle-o" />
                      Manage Official Tag
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Master : Official Songs */}
              <li>
                <a
                  href="#Officialsongs-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-music"></i> <span>Songs</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Officialsongs-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addSongs">
                      <i className="fa fa-circle-o" />
                      Add Songs
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageSongs">
                      <i className="fa fa-circle-o" />
                      Manage Songs
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Master : Official Plan */}
              <li>
                <a
                  href="#Officialplan-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-money-check-dollar"></i> <span>Plans</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Officialplan-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addPlan">
                      <i className="fa fa-circle-o" />
                      Add Plan
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/managePlan">
                      <i className="fa fa-circle-o" />
                      Manage Plan
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/InvoiceInfo">
                      <i className="fa fa-circle-o" />
                      Manage Invoice
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Master : Official Video Content */}
              <li>
                <a
                  href="#OfficialVideoContent-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-file-video"></i> <span>Video Content</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="OfficialVideoContent-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addContent">
                      <i className="fa fa-circle-o" />
                      Add Content
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageContent">
                      <i className="fa fa-circle-o" />
                      Manage Content
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Master : Official Gift */}
              <li>
                <a
                  href="#Gift-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i
                    class="fa-solid fa-gift"
                    style={{ marginRight: "8px" }}
                  ></i>{" "}
                  <span> Gift</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Gift-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addGift">
                      <i className="fa fa-circle-o" />
                      Add Gift
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageGift">
                      <i className="fa fa-circle-o" />
                      View Gift
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Master : Live Gifts s */}
              <li>
                <a
                  href="#LiveGift-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-hand-holding-heart"></i>{" "}
                  <span> Live Gift</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="LiveGift-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/manageLiveGiftCategory">
                      <i className="fa fa-circle-o" />
                      Gift Category
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/addLiveGift">
                      <i className="fa fa-circle-o" />
                      Add Live Gift
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageLiveGift">
                      <i className="fa fa-circle-o" />
                      View Live Gift
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Master : Official Gift */}
              <li>
                <a
                  href="#Gifs-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i
                    class="fa-solid fa-gift"
                    style={{ marginRight: "8px" }}
                  ></i>{" "}
                  <span> GIFs</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Gifs-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addGifs">
                      <i className="fa fa-circle-o" />
                      Add GIFs
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageGifs">
                      <i className="fa fa-circle-o" />
                      View GIFs
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Master : Mall s */}
              <li className="header">Store</li>
              {/* Entry Effect s */}
              <li className="LINK_CLASS">
                <Link to="admin/FamilyPKBattle">
                  <i className="fa fa-diamond" />
                  Create PKBanner
                </Link>
              </li>
              <li>
                <a
                  href="#Entryeffect-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i
                    class="fa-solid fa-gopuram"
                    style={{ marginRight: "5px" }}
                  ></i>{" "}
                  <span>Entry Effects</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Entryeffect-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addEntryEffect">
                      <i className="fa fa-circle-o" />
                      Add Entry Effects
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageEntryEffect">
                      <i className="fa fa-circle-o" />
                      View Entry Effects
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Frame s */}
              <li>
                <a
                  href="#Frames-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-border-top-left"></i> <span>Frames</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Frames-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addFrames">
                      <i className="fa fa-circle-o" />
                      Add Frame
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageFrames">
                      <i className="fa fa-circle-o" />
                      View Frame
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Wallpaper s */}
              <li>
                <a
                  href="#Wallpaper-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i
                    class="fa-brands fa-ethereum"
                    style={{ marginRight: "5px" }}
                  ></i>{" "}
                  <span>Theme</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Wallpaper-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addTheme">
                      <i className="fa fa-circle-o" />
                      Add Theme
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/manageTheme">
                      <i className="fa fa-circle-o" />
                      View Theme
                    </Link>
                  </li>
                </ul>
              </li>
              {/* backgroundtheme */}
              <li>
                <a
                  href="#Wallpaper-infoo"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i
                    class="fa-brands fa-ethereum"
                    style={{ marginRight: "5px" }}
                  ></i>{" "}
                  <span>Background Theme</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Wallpaper-infoo"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/backgroundtheme">
                      <i className="fa fa-circle-o" />
                      View Background Theme
                    </Link>
                  </li>
                </ul>
              </li>
              {/* =============================== */}
              <li className="header">Commission Table</li>
              {/* Master : Recharge s */}
              <li>
                <a
                  href="#comm-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-bolt"></i> <span>Commission</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="comm-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/addcommission">
                      <i className="fa fa-circle-o" />
                      Add Commission
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/viewcommission">
                      <i className="fa fa-circle-o" />
                      View Commission
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/addconversion">
                      <i className="fa fa-circle-o" />
                      Add Conversion
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/viewconversion">
                      <i className="fa fa-circle-o" />
                      View Conversion
                    </Link>
                  </li>
                </ul>
              </li>
              {/* Level */}
              {/* =============================== */}
              <li className="header">LEVELS</li>
              {/* Master : level s */}
              <li>
                <a
                  href="#Mylevel-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-list-check"></i> <span>My Level</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="Mylevel-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/manageLevel">
                      <i className="fa fa-circle-o" />
                      Manage Levels
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/addLevel">
                      <i className="fa fa-circle-o" />
                      Add Level
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/addentryEffectslevel">
                      <i className="fa fa-circle-o" />
                      Add EntryEffects Levels
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/entryEffectslevel">
                      <i className="fa fa-circle-o" />
                      EntryEffects Levels
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/addframelevel">
                      <i className="fa fa-circle-o" />
                      Add Frame Levels
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/framelevel">
                      <i className="fa fa-circle-o" />
                      Frame Levels
                    </Link>
                  </li>
                </ul>
              </li>
              {/* =============================== */}
              {/* Recharge */}
              {/* =============================== */}
              <li className="header">RECHARGE</li>
              {/* Master : Recharge s */}
              <li>
                <a
                  href="#recharge-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-bolt"></i> <span>Recharge</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="recharge-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/sendCoins">
                      <i className="fa fa-circle-o" />
                      Send Coins
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/rechargeHistory">
                      <i className="fa fa-circle-o" />
                      Recharge History
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/Payments">
                      <i className="fa fa-circle-o" />
                      Razorpay Payments
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/GetLiveAmountInRange">
                      <i className="fa fa-circle-o" />
                      Send MCoins 
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href="#game-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i class="fa fa-bolt"></i> <span>Games</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="game-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/admin/GamesData">
                      <i className="fa fa-circle-o" />
                      Games Payments
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/GameLevelReq">
                      <i className="fa fa-circle-o" />
                      Games Level Required
                    </Link>
                  </li>
                </ul>
              </li>
              {/* =============================== */}
              {/* Admin Account */}
              {/* =============================== */}
              <li className="header">Admin Account</li>
              <li className="LINK_CLASS">
                <Link to="admin/profile">
                  <i className="fa fa-diamond" />
                  Account
                </Link>
              </li>
              <li className="LINK_CLASS">
                <Link to="admin/AgreementsUpload">
                  <i className="fa fa-diamond" />
                  Agreements Upload
                </Link>
              </li>
              <li className="LINK_CLASS">
                <Link to="admin/history">
                  <i className="fa fa-diamond" />
                  Admin History 
                </Link>
              </li>
              <li className="LINK_CLASS">
                <Link to="admin/video-storage-config">
                  <i className="fa fa-cloud-upload-alt" />
                  Video Storage Config
                </Link>
              </li>
              <li className="LINK_CLASS">
                <Link to="admin/asset-storage-config">
                  <i className="fa fa-cloud-upload-alt" />
                  Asset Storage Config
                </Link>
              </li>
              {/* Database Manager - Only for Super Admins (access === '1') */}
              {allowed && details?.access === '1' && (
                <li className="LINK_CLASS">
                  <Link to="admin/database">
                    <i className="fa fa-database" />
                    Database Manager
                  </Link>
                </li>
              )}
              <li
                onClick={() => {
                  adminStorage.clear();
                  window.location.href = "/";
                }}
              >
                <Link href="/admin/logout">
                  <i className="fa fa-sign-out" />
                  Sign Out
                </Link>
              </li>
            </ul>
          </section>

          {/* /.sidebar */}
        </aside>
      ) : isAgencyAdminPanel ? (
        <aside
          className="main-sidebar"
          style={{ maxHeight: "95vh", overflow: "auto" }}
        >
          <section className="sidebar" >
            <div className="user-panel" style={{ minHeight: "15vh", margin: "2px" }}>
              <div className="pull-left image">
                <img
                  src={`${process.env.REACT_APP_BASEURL}${AgencyADetails?.image}`}
                  className="img-circle"
                  alt="User Image"
                  style={{ height: "50px", width: "50px" }}
                />
              </div>
              <div className="pull-left info">
                <p>{AgencyADetails?.name}</p>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p style={{ fontSize: "9px", margin: 0 }}>{AgencyADetails?.uniqueId}</p>
                  <CopyToClipboard text={AgencyADetails?.uniqueId} onCopy={handleCopy}>
                    {copied ? (
                      <FaCheck style={{ marginLeft: '4px', cursor: 'pointer', color: 'green' }} />
                    ) : (
                      <FaCopy style={{ marginLeft: '4px', cursor: 'pointer' }} />
                    )}
                  </CopyToClipboard>
                </div>
                <a href="#">
                  <i className="fa fa-circle text-success" /> Online
                </a>
              </div>
            </div>
            <ul
              className="sidebar-menu"
              dataWidget="tree"
              id="iq-sidebar-toggle"
            >
              {/* ============================================================================== */}
              {/* MASTER */}
              {/* ============================================================================== */}
              <li className="active">
                <Link to="/agencyadmin/dashboard">
                  <i className="fa fa-dashboard" />
                  Agency Admin Panel
                </Link>
              </li>
              {/* =============================== */}
              {/* Account Management */}
              {/* =============================== */}
              <li className="header">ACCOUNTS MANAGEMENT</li>
              {/* Master : Users e */}
              {/* ritul */}

              <li>
                <a
                  href="#user-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-user" /> <span>Agency </span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="user-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/agencyadmin/addagency">
                      <i className="fa fa-circle-o" />
                      Add Agency
                    </Link>
                  </li>
                  <li>
                    <Link to="/agencyadmin/manageagency">
                      <i className="fa fa-circle-o" />
                      Manage Agency
                    </Link>
                  </li>
                </ul>
              </li>
              {/* ================= */}
              <li>
                <a
                  href="#host-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-user" /> <span>Host </span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="host-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/agencyadmin/pendinghost">
                      <i className="fa fa-circle-o" />
                      Pending Hosts
                    </Link>
                  </li>
                  <li>
                    <Link to="/agencyadmin/rejectedhost">
                      <i className="fa fa-circle-o" />
                      Rejected Hosts
                    </Link>
                  </li>
                  <li>
                    <Link to="/agencyadmin/approvedhost">
                      <i className="fa fa-circle-o" />
                      Approved Hosts
                    </Link>
                  </li>
                </ul>
              </li>
              {/* ================= */}
              <li>
                <a
                  href="#host-info-w"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-user" /> <span>Withdrawal </span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="host-info-w"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/agencyadmin/agencywithdrawal">
                      <i className="fa fa-circle-o" />
                      Total Withdrawal
                    </Link>
                  </li>

                </ul>
              </li>
              <li>
                <Link
                  to="/agencyadmin/Seniors"

                >
                  <i className="fa fa-user" /> <span>Seniors </span>
                  <span className="pull-right-container">
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  to="/agencyadmin/getTargetWith"

                >
                  <i className="fa fa-user" /> <span>Set Target Withdrawal </span>
                  <span className="pull-right-container">
                  </span>
                </Link>
              </li>

              <li className="header">Admin Account</li>
              <li className="LINK_CLASS">
                <Link to="/agencyadmin/aaprofile">
                  <i className="fa fa-diamond" />
                  Account
                </Link>
              </li>
                 <li className="LINK_CLASS">
                <Link to="/agencyadmin/submitkyc">
                  <i className="fa fa-diamond" />
                  KYC
                </Link>
              </li>
              <li
                onClick={() => {
                  sessionStorage.removeItem("agencyadmin");
                  setTimeout(() => {
                    window.location.pathname = "/agencyadmin";
                  });
                }}
              >
                <a>
                  <i className="fa fa-sign-out" />
                  Sign Out
                </a>
              </li>
            </ul>
          </section>
          {/* /.sidebar */}
        </aside>
      ) : isAgencyPanel ? (
        <aside
          className="main-sidebar"
          style={{ maxHeight: "95vh", overflow: "auto" }}
        >
          <section className="sidebar">
            <div className="user-panel" style={{ minHeight: "15vh", margin: "2px" }}>
              <div className="pull-left image">
                <img
                  src={`${process.env.REACT_APP_BASEUR1}${AgencyDetails?.image}`}
                  className="img-circle"
                  alt="User Image"
                  style={{ height: "50px", width: "50px" }}
                />
              </div>
              <div className="pull-left info">
                <p>{AgencyDetails?.name}</p>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p style={{ fontSize: "9px", margin: 0 }}>{AgencyDetails?.uniqueId}</p>
                  <CopyToClipboard text={AgencyDetails?.uniqueId} onCopy={handleCopy}>
                    {copied ? (
                      <FaCheck style={{ marginLeft: '4px', cursor: 'pointer', color: 'green' }} />
                    ) : (
                      <FaCopy style={{ marginLeft: '4px', cursor: 'pointer' }} />
                    )}
                  </CopyToClipboard>
                </div>
                <a href="#">
                  <i className="fa fa-circle text-success" /> Online
                </a>
              </div>
            </div>
            <ul
              className="sidebar-menu"
              dataWidget="tree"
              id="iq-sidebar-toggle"
            >
              {/* ============================================================================== */}
              {/* MASTER */}
              {/* ============================================================================== */}
              <li className="active">
                <Link to="/agency/dashboard">
                  <i className="fa fa-dashboard" />
                  Dashboard Agency Panel
                </Link>
              </li>
              {/* =============================== */}
              {/* Account Management */}
              {/* =============================== */}
              <li className="header">ACCOUNTS MANAGEMENT</li>
              {/* Master : Users e */}
              {/* ritul */}
              <li>
                <a
                  href="#user-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-user" /> <span>Agency Host</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="user-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/agency/pendingHost">
                      <i className="fa fa-circle-o" />
                      Pending Hosts
                    </Link>
                  </li>
                  <li>
                    <Link to="/agency/rejectedHost">
                      <i className="fa fa-circle-o" />
                      Rejected Hosts
                    </Link>
                  </li>
                  <li>
                    <Link to="/agency/approvedHost">
                      <i className="fa fa-circle-o" />
                      Approved Hosts
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href="#bdbill-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-user" /> <span>Bills</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="bdbill-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/agency/PreviousBills">
                      <i className="fa fa-circle-o" />
                      Withdrawal Bills
                    </Link>
                  </li>
                </ul>
              </li>
              {/* divansh */}

              {/* Master : Host s */}
              <li>
                {/* <a
                  href="#Host-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                > */}
                <Link to="/agency/hostrecord">
                  <i className="fa fa-user" /> <span>Host Record</span>
                </Link>
                {/* <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span> */}
                {/* </a> */}
              </li>
              <li>
                {/* <a
                  href="#Host-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                > */}
                <Link to="/agency/hostwithdrawal">
                  <i className="fa fa-user" /> <span>Total Withdrawal</span>
                </Link>
                {/* <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span> */}
                {/* </a> */}
              </li>
              <li>
                <Link
                  to="/agency/Seniors"

                >
                  <i className="fa fa-user" /> <span>Seniors </span>
                  <span className="pull-right-container">
                  </span>
                </Link>
              </li>

              {/* =============================== */}
              {/* Admin Account */}
              {/* =============================== */}
              <li className="header">Agency Account</li>
              <li className="LINK_CLASS">
                <Link to="/agency/profile">
                  <i className="fa fa-diamond" />
                  Account
                </Link>
              </li>
              <li className="LINK_CLASS">
                <Link to="/agency/submitkyc">
                  <i className="fa fa-diamond" />
                  KYC
                </Link>
              </li>
              <li
                onClick={() => {
                  sessionStorage.removeItem("agency");
                  setTimeout(() => {
                    window.location.pathname = "/agency";
                  });
                }}
              >
                <a>
                  <i className="fa fa-sign-out" />
                  Sign Out
                </a>
              </li>
            </ul>
          </section>
          {/* /.sidebar */}
        </aside>
      ) : isBdPanel ? (
        <aside
          className="main-sidebar"
          style={{ maxHeight: "95vh", overflow: "auto" }}
        >
          <section className="sidebar">
            <div className="user-panel" style={{ minHeight: "15vh", margin: "2px" }}>
              <div className="pull-left image">
                <img
                  src={`${process.env.REACT_APP_BASEURL}${bD?.image}`}
                  className="img-circle"
                  alt="User Image"
                  style={{ height: "50px", width: "50px" }}
                />
              </div>
              <div className="pull-left info">
                <p>{bD?.name}</p>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p style={{ fontSize: "9px", margin: 0 }}>{bD?.uniqueId}</p>
                  <CopyToClipboard text={bD?.uniqueId} onCopy={handleCopy}>
                    {copied ? (
                      <FaCheck style={{ marginLeft: '4px', cursor: 'pointer', color: 'green' }} />
                    ) : (
                      <FaCopy style={{ marginLeft: '4px', cursor: 'pointer' }} />
                    )}
                  </CopyToClipboard>
                </div>
                <a href="#">
                  <i className="fa fa-circle text-success" /> Online
                </a>
              </div>
            </div>
            <ul
              className="sidebar-menu"
              dataWidget="tree"
              id="iq-sidebar-toggle"
            >
              <li className="active">
                <Link to="/bd/dashboard">
                  <i className="fa fa-dashboard" />
                  Dashboard BD Panel
                </Link>
              </li>

              <li className="header">ACCOUNTS MANAGEMENT</li>
              <li>
                <a
                  href="#user-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-user" /> <span>Agency Admin</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="user-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/bd/addagencyadmin">
                      <i className="fa fa-circle-o" />
                      Add Agency Admin
                    </Link>
                  </li>
                  <li>
                    <Link to="/bd/manageagencyadmin">
                      <i className="fa fa-circle-o" />
                      Manage Agency Admin
                    </Link>
                  </li>
                </ul>
              </li>
              {/* //////////////////////// */}
              <li>
                <a
                  href="#user-agency"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-user" /> <span>Agency </span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="user-agency"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/bd/addagency">
                      <i className="fa fa-circle-o" />
                      Add Agency
                    </Link>
                  </li>
                  <li>
                    <Link to="/bd/manageagency">
                      <i className="fa fa-circle-o" />
                      Manage Agency
                    </Link>
                  </li>
                  <li>
                    <Link to="/bd/pendingAgencyListReq">
                      <i className="fa fa-circle-o" />
                      Pending Agency
                    </Link>
                  </li>
                  <li>
                    <Link to="/bd/AgencyBillListToBd">
                      <i className="fa fa-circle-o" />
                      AgencyBill
                    </Link>
                  </li>
                </ul>
              </li>
              {/* /////////////////////// */}
              <li>
                <a
                  href="#bdhost-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-user" /> <span>Agency Admin Host</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="bdhost-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/bd/pandinghost">
                      <i className="fa fa-circle-o" />
                      Pending Host
                    </Link>
                  </li>
                  <li>
                    <Link to="/bd/approvedhost">
                      <i className="fa fa-circle-o" />
                      Approved Host
                    </Link>
                  </li>
                  <li>
                    <Link to="/bd/rejectedhost">
                      <i className="fa fa-circle-o" />
                      Rejected Host
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href="#bdbill-info"
                  class="collapsed"
                  data-toggle="collapse"
                  aria-expanded="false"
                >
                  <i className="fa fa-user" /> <span>Bills</span>
                  <span className="pull-right-container">
                    <i className="fa fa-angle-left pull-right" />
                  </span>
                </a>
                <ul
                  id="bdbill-info"
                  class="collapse nestedullistss"
                  data-parent="#iq-sidebar-toggle"
                >
                  <li>
                    <Link to="/bd/InvoiceForBd">
                      <i className="fa fa-circle-o" />
                      Current Bill
                    </Link>
                  </li>
                  <li>
                    <Link to="/bd/PreviousBills">
                      <i className="fa fa-circle-o" />
                      Previous Bills
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to={"/bd/liveuser"}>
                  <a >
                    <i className="fa fa-user" /> <span>User Live </span>
                  </a>
                </Link>
              </li>
              <li>
                <Link to={"/bd/FamilyWalletWithdrawalBD"}>
                  <a>
                    <i className="fa fa-user" /> <span>Family WithDrawal </span>
                  </a>
                </Link>
              </li>
              {/* <li>
                <Link to={"/bd/storedwithdrawalfamilyAAlists"}>
                  <a>
                    <i className="fa fa-user" /> <span>Family WithDrawal </span>
                  </a>
                </Link>
              </li> */}
              <li>
                <Link to={"/bd/list"}>
                  <a>
                    <i className="fa fa-user" /> <span>Total WithDrawal </span>
                  </a>
                </Link>
              </li>
              <li>
                <Link to={"/bd/bannedusers"}>
                  <a>
                    <i className="fa fa-user" /> <span>Banned Users </span>
                  </a>
                </Link>
              </li>
              <li>
                <Link to={"bd/getTargetWith"}>
                  <a>
                    <i className="fa fa-user" /> <span>Set Target Withdrawal </span>
                  </a>
                </Link>
              </li>
              {bD && (bD?.uniqueId == "bd@6319098566" || bD?.uniqueId == "bd@6319279182") && <li className="LINK_CLASS">
                <Link to={"bd/FamilyPKBattle"}>
                  <i className="fa fa-diamond" />
                  Create PkBanner
                </Link>
              </li>}
              {bD && (bD?.uniqueId == "bd@6319098566" || bD?.uniqueId == "bd@6319279182") && <li className="LINK_CLASS">
                <Link to={"bd/PKBattleRoundFirst"}>
                  <i className="fa fa-diamond" />
                  PKBattle Round1
                </Link>
              </li>}
              {bD && (bD?.uniqueId == "bd@6319098566" || bD?.uniqueId == "bd@6319279182") && <li className="LINK_CLASS">
                <Link to={"bd/PKBattleRoundSecond"}>
                  <i className="fa fa-diamond" />
                  PKBattle Round2
                </Link>
              </li>}
              {bD && (bD?.uniqueId == "bd@6319098566" || bD?.uniqueId == "bd@6319279182") && <li className="LINK_CLASS">
                <Link to={"bd/PKBattleRoundThird"}>
                  <i className="fa fa-diamond" />
                  PKBattle Round3
                </Link>
              </li>}
              {bD && (bD?.uniqueId == "bd@6319098566" || bD?.uniqueId == "bd@6319279182") && <li className="LINK_CLASS">
                <Link to={"bd/PKBattleRoundFinal"}>
                  <i className="fa fa-diamond" />
                  PKBattle RoundFinal
                </Link>
              </li>}
              {bD && (bD?.uniqueId == "bd@6319098566" || bD?.uniqueId == "bd@6319279182") && <li className="LINK_CLASS">
                <Link to={"/bd/categoryBanner"}>
                  <i className="fa fa-diamond" />
                  Category Banner
                </Link>
              </li>}
              {/* {bD && bD?.uniqueId == "bd@6319098566" && <li className="LINK_CLASS">
                <Link to={"/bd/hipe/hipebanner"}>
                  <i className="fa fa-diamond" />
                  Hipe Banner1
                </Link>
              </li>} */}
              {bD && (bD?.uniqueId == "bd@6319098566" || bD?.uniqueId == "bd@6319279182") && <li className="LINK_CLASS">
                <Link to="/bd/PKBattleComponent">
                      <i className="fa fa-circle-o" />
                      FamilyPk
                    </Link>
              </li>}

              {/* /////////////////////// */}
              {/* Bd Host */}
              <li className="header">BD Account</li>
              <li className="LINK_CLASS">
                <Link to="/bd/profile">
                  <i className="fa fa-diamond" />
                  Account
                </Link>
              </li>
                 <li className="LINK_CLASS">
                <Link to="/bd/submitkyc">
                  <i className="fa fa-diamond" />
                  KYC
                </Link>
              </li>
              <li
                onClick={() => {
                  sessionStorage.removeItem("bd");
                  setTimeout(() => {
                    window.location.pathname = "/bd";
                  });
                }}
              >
                <a>
                  <i className="fa fa-sign-out" />
                  Sign Out
                </a>
              </li>
            </ul>
          </section>
          {/* /.sidebar */}
        </aside>
      ) : (
        <aside
          className="main-sidebar"
          style={{ maxHeight: "95vh", overflow: "auto" }}
        >
          <section className="sidebar">
            <div className="user-panel" style={{ minHeight: "15vh", margin: "2px" }}>
              <div className="pull-left image">
                <img
                  src={`${process.env.REACT_APP_BASEURL}${coinDetails?.image}`}
                  className="img-circle"
                  alt="User Image"
                  style={{ height: "50px", width: "50px" }}
                />
              </div>
              <div className="pull-left info">
                <p>{coinDetails?.name}</p>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <p style={{ fontSize: "9px", margin: 0 }}>{coinDetails?.uniqueId}</p>
                  <CopyToClipboard text={coinDetails?.uniqueId} onCopy={handleCopy}>
                    {copied ? (
                      <FaCheck style={{ marginLeft: '4px', cursor: 'pointer', color: 'green' }} />
                    ) : (
                      <FaCopy style={{ marginLeft: '4px', cursor: 'pointer' }} />
                    )}
                  </CopyToClipboard>
                </div>
                <a href="#">
                  <i className="fa fa-circle text-success" /> Online
                </a>
              </div>
            </div>
            <ul
              className="sidebar-menu"
              dataWidget="tree"
              id="iq-sidebar-toggle"
            >
              {/* ============================================================================== */}
              {/* MASTER */}
              {/* ============================================================================== */}
              <li className="active">
                <Link to="/coin/dashboard">
                  <i className="fa fa-dashboard" />
                  Dashboard Coin Panel
                </Link>
              </li>

              <li className="header">ACCOUNTS MANAGEMENT master</li>

              <li>
                <Link to="/coin/sendcoin">
                  <i className="fa fa-user" /> <span>Send Coins</span>
                </Link>
              </li>
              <li>
                <Link to="/coin/history">
                  <i className="fa fa-user" /> <span>Coin History</span>
                </Link>
              </li>
              <li>
                <Link to="/coin/received">
                  <i className="fa fa-user" /> <span>Receive History</span>
                </Link>
              </li>
              <li>
                <Link to="/coin/returnHistory">
                  <i className="fa fa-user" /> <span>Return History</span>
                </Link>
              </li>
              <li className="header">Admin Account</li>
              <li className="LINK_CLASS">
                <Link to="/coin/profile">
                  <i className="fa fa-diamond" />
                  Account
                </Link>
              </li>
                 <li className="LINK_CLASS">
                <Link to="/coin/submitkyc">
                  <i className="fa fa-diamond" />
                  KYC
                </Link>
              </li>
              <li
                onClick={() => {
                  sessionStorage.removeItem("coin");
                  window.location.href = "/coin";
                }}
              >
                <a>
                  <i className="fa fa-sign-out" />
                  Sign Out
                </a>
              </li>
            </ul>
          </section>
          {/* /.sidebar */}
        </aside>
      )}
    </>
  );
});

export default Aside;
